import {
  DataDrivenPropertyValueSpecification,
  LayerSpecification,
} from "maplibre-gl";
import { MAP_COLORS, MAP_LAYERS } from "./constants";
import { OPACITIES } from "./mapStyling/styleConstants";

export const SEARCHED_ADD_LAYER: LayerSpecification = {
  id: MAP_LAYERS.searchedAddress,
  source: MAP_LAYERS.searchedAddress,
  type: "symbol",
  layout: {
    visibility: "none",
    "icon-image": "house-marker",
    "icon-size": 0.5,
  },
};

export const PLANNING_BLOCK_LAYER: LayerSpecification = {
  id: MAP_LAYERS.planningBlocks,
  source: MAP_LAYERS.planningBlocks,
  "source-layer": "features",
  type: "fill",
  layout: {
    visibility: "none",
  },
  paint: {
    "fill-color": ["get", "es_0_color"],
    "fill-opacity": OPACITIES.DEFAULT,
  },
};

export const PLANNING_BLOCK_CHANGE_LAYER: LayerSpecification = {
  id: MAP_LAYERS.planningBlockChanges,
  source: MAP_LAYERS.planningBlockChanges,
  "source-layer": "features",
  type: "fill",
  layout: {
    visibility: "none",
  },
  paint: {
    "fill-color": "#000000",
    "fill-opacity": 1,
    "fill-pattern": "hatch-pattern",
  },
};

export const DUAL_RIGHTS_LAYER: LayerSpecification = {
  id: MAP_LAYERS.dualRights,
  source: MAP_LAYERS.dualRights,
  "source-layer": "features",
  type: "fill",
  layout: {
    visibility: "none",
  },
  paint: {
    "fill-color": "#000000",
    "fill-opacity": 1,
    "fill-pattern": "horizontal-pattern",
  },
};

export const ALL_BOUNDARIES_LAYER: LayerSpecification = {
  id: MAP_LAYERS.allBoundaries,
  source: MAP_LAYERS.allBoundaries,
  type: "line",
  layout: {
    "line-sort-key": ["+", ["get", "index"]],
    visibility: "none",
  },
  paint: {
    "line-width": ["match", ["get", "level"], "ES", 2, "MS", 3, "HS", 3, 0],
    "line-offset": ["match", ["get", "level"], "ES", 0, "MS", 0, "HS", 0, 0],

    "line-color": [
      "match",
      ["get", "level"],
      "ES",
      MAP_COLORS.ES,
      "MS",
      MAP_COLORS.MS,
      "HS",
      MAP_COLORS.HS,
      "#FFF",
    ],
  },
};

export const PLANNING_BLOCK_SWAPPABLE: LayerSpecification = {
  id: MAP_LAYERS.swappableBlocks,
  type: "fill",
  source: MAP_LAYERS.swappableBlocks,
  layout: {
    visibility: "none",
  },

  paint: {
    "fill-color": "transparent",
    "fill-opacity": OPACITIES.DEFAULT,
    "fill-outline-color": MAP_COLORS.GREY,
  },
};

export const schoolPointColoring: DataDrivenPropertyValueSpecification<string> =
  [
    "match",
    ["get", "school_sector"],
    "DCPS Citywide",
    "#fff",
    "DCPS by-right",
    ["get", "color"],
    "#000",
  ];

export const SCHOOL_POINTS: LayerSpecification = {
  id: MAP_LAYERS.schoolPoints,
  source: MAP_LAYERS.schoolPoints,
  type: "circle",
  layout: {
    visibility: "none",
  },
  paint: {
    // rules based on sector
    "circle-color": schoolPointColoring,
    "circle-opacity": 1,
    "circle-stroke-width": 1,
    "circle-radius": [
      "match",
      ["get", "school_sector"],
      "DCPS Citywide",
      4,
      "DCPS by-right",
      7,
      4,
    ],
  },
};

export const SCHOOL_BOUNDARIES: LayerSpecification = {
  id: MAP_LAYERS.schoolBoundaries,
  source: MAP_LAYERS.schoolBoundaries,
  "source-layer": "features",
  type: "line",
  layout: {
    visibility: "none",
  },
  paint: {
    "line-opacity": 0,
    "line-width": 1,
    "line-color": MAP_COLORS.BLACK,
  },
};
